import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../AppIcon';

const BrandLogo = ({ 
  size = 'md', 
  linkTo = '/', 
  className = '',
  showIcon = true,
  showText = true,
  subtitle = null,
  showBeta = true 
}) => {
  const sizeClasses = {
    sm: 'h-6',
    md: 'h-8',
    lg: 'h-10',
    xl: 'h-12'
  };

  const textSizeClasses = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl',
    xl: 'text-3xl'
  };

  const iconSizeMap = {
    sm: 20,
    md: 24,
    lg: 28,
    xl: 32
  };

  const LogoContent = () => (
    <div className={`flex items-center space-x-2 ${className}`}>
      {showIcon && (
        <div className="flex items-center justify-center w-8 h-8 bg-primary rounded-lg">
          <Icon 
            name="Zap" 
            size={iconSizeMap?.[size]} 
            color="white"
            strokeWidth={2.5}
          />
        </div>
      )}
      {showText && (
        <div className="flex flex-col">
          <div className="flex items-center space-x-2">
            <span className={`font-bold text-foreground leading-none ${textSizeClasses?.[size]}`}>
              Recrutees
            </span>
            {showBeta && (
              <span className="px-1.5 py-0.5 text-xs font-semibold text-orange-600 bg-orange-100 rounded-full border border-orange-200">
                Beta
              </span>
            )}
          </div>
          {subtitle ? (
            <span className="text-xs text-primary font-medium leading-none mt-0.5">
              {subtitle}
            </span>
          ) : (
            <span className="text-xs text-primary font-medium leading-none mt-0.5">
              AI Recruiting
            </span>
          )}
        </div>
      )}
    </div>
  );

  if (linkTo) {
    return (
      <Link 
        to={linkTo}
        className="inline-flex items-center transition-opacity duration-200 hover:opacity-80 focus:outline-none focus:opacity-80 rounded-lg"
        aria-label="Recrutees - AI Recruiting Platform (Beta)"
      >
        <LogoContent />
      </Link>
    );
  }

  return <LogoContent />;
};

export default BrandLogo;